export default __webpack_public_path__ + "media/images/message-5f9683582c1ada2cc0b471f6e14de9c0.svg";